import { Component, OnInit, EventEmitter, Output, OnDestroy } from '@angular/core';
import { ModalService } from '@services/modal.service';

@Component({
  selector: 'app-modal-transaction-check-confirm',
  templateUrl: './modal-transaction-check-confirm.component.html',
  styleUrls: ['./modal-transaction-check-confirm.component.scss']
})
export class ModalTransactionCheckConfirmComponent implements OnDestroy {

  @Output() confirm: EventEmitter<object> = new EventEmitter();
  constructor(public modal: ModalService) {  }

  ngOnDestroy() {
    this.modal.close();
  }

  accept() {
    this.modal.close();
    this.confirm.emit();
  }

}
